var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31 10h-14a1 1 0 0 1 -1-1v-6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1zm-13-2h12v-4h-12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 25h2v6h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41 29h-5v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1v-3h-12v3a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1-1v-3h-5a6.9445 6.9445 0 0 1 -3-.6851v14.6851a3.0033 3.0033 0 0 0 3 3h34a3.0033 3.0033 0 0 0 3-3v-14.6851a6.9445 6.9445 0 0 1 -3 .6851z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14 25h2v6h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45 8h-42a1 1 0 0 0 -1 1v13a5.0059 5.0059 0 0 0 5 5h5v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h12v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3h5a5.0059 5.0059 0 0 0 5-5v-13a1 1 0 0 0 -1-1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.6b297ae4.svg";
export { ForwardRef as ReactComponent };